// Container imports
const { SHOW, HIDE } = require('./actions')
const AuthModalRecord = require('./record')

function authModalReducer(state, { type, payload }) {
  // Sanity check
  if (state !== null && !(state instanceof AuthModalRecord)) {
    return state
  }
  switch (type) {
    case SHOW:
      return (state || new AuthModalRecord).show(payload)
    case HIDE:
      return state && state.hide()
    default:
      return state
  }
}

module.exports = authModalReducer
